<template>
  <div class="group-443">
    <div class="view-499">
      <div class="rectangle-85-6"></div>
      <img
        class="image-51"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/---------9@2x.png"
        alt="image"
      />
      <div class="text-503 poppins-bold-black-17px">Участники</div>
    </div>
    <div class="view-500">
      <div class="rectangle-85-7"></div>
      <div class="view-501">
        <x182 :number="x1821Props.number" :group234="x1821Props.group234" :text524="x1821Props.text524" />
        <img
          class="line-22-4"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-23-1.svg"
          alt="Line 22"
        />
        <x182
          :number="x1822Props.number"
          :group234="x1822Props.group234"
          :text524="x1822Props.text524"
          :className="x1822Props.className"
        />
        <img
          class="line-2"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-23-1.svg"
          alt="Line 22"
        />
        <x362
          :number="x3621Props.number"
          :group234="x3621Props.group234"
          :text520="x3621Props.text520"
          :text519="x3621Props.text519"
        />
        <img
          class="line-2"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-23-1.svg"
          alt="Line 23"
        />
        <x362
          :number="x3622Props.number"
          :group234="x3622Props.group234"
          :text520="x3622Props.text520"
          :text519="x3622Props.text519"
          :className="x3622Props.className"
        />
        <img
          class="line-24"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-24-6.svg"
          alt="Line 24"
        />
        <x362
          :number="x3623Props.number"
          :group234="x3623Props.group234"
          :text520="x3623Props.text520"
          :text519="x3623Props.text519"
          :className="x3623Props.className"
        />
        <div class="x6-15 poppins-bold-white-15px">
          <div class="rectangle-85-8"></div>
          <div class="text-490">86,4</div>
          <div class="text-491">Вы</div>
          <div class="group-235-15"></div>
          <div class="number-8">20</div>
        </div>
      </div>
      <p class="text-502 poppins-bold-black-17px">ТОП - 5 студентов на курсе</p>
    </div>
  </div>
</template>

<script>
import X182 from "./X182";
import X362 from "./X362";
export default {
  name: "Group443",
  components: {
    X182,
    X362,
  },
  props: ["x1821Props", "x1822Props", "x3621Props", "x3622Props", "x3623Props"],
};
</script>

<style>
.group-443,
.group-443-1 {
  display: flex;
  flex-direction: column;
  height: 846px;
  width: 415px;
}

.view-499,
.view-502 {
  align-self: center;
  height: 423px;
  margin-left: 2px;
  position: relative;
  width: 417px;
}

.rectangle-85-6,
.rectangle-85-9 {
  background-color: var(--white);
  height: 423px;
  left: calc(50% - 208px);
  position: absolute;
  top: 0;
  width: 415px;
}

.image-51,
.image-52 {
  height: 335px;
  left: 40px;
  position: absolute;
  top: 54px;
  width: 335px;
}

.text-503,
.text-654 {
  left: 158px;
  letter-spacing: 0.34px;
  line-height: normal;
  position: absolute;
  top: 12px;
}

.view-500,
.view-503 {
  height: 423px;
  position: relative;
  width: 417px;
}

.rectangle-85-7,
.rectangle-85-10 {
  background-color: var(--white);
  border-radius: 0px 0px 20px 20px;
  height: 423px;
  left: 0;
  position: absolute;
  top: 0;
  width: 415px;
}

.view-501,
.view-504 {
  display: flex;
  flex-direction: column;
  height: 359px;
  left: calc(50% - 208px);
  position: absolute;
  top: 64px;
  width: 415px;
}

.line-22-4,
.line-22-5 {
  align-self: center;
  height: 1px;
  margin-left: -3px;
  margin-top: 3.5px;
  width: 340.01px;
}

.line-2,
.line-2-1 {
  align-self: center;
  height: 1px;
  margin-left: -3px;
  margin-top: 2.5px;
  width: 340.01px;
}

.line-24,
.line-24-1 {
  align-self: center;
  height: 1px;
  margin-left: -3px;
  margin-top: 3px;
  width: 340.01px;
}

.x6-15,
.x6-16 {
  height: 52px;
  margin-top: 8px;
  position: relative;
  width: 421px;
}

.rectangle-85-8,
.rectangle-85-11 {
  background-color: var(--azure-radiance-3);
  border-radius: 20px;
  height: 52px;
  left: 0;
  position: absolute;
  top: 0;
  width: 415px;
}

.text-490,
.text-641 {
  left: 341px;
  letter-spacing: 0.3px;
  line-height: normal;
  position: absolute;
  top: 13px;
}

.text-491,
.text-642 {
  left: 121px;
  letter-spacing: 0.3px;
  line-height: normal;
  position: absolute;
  top: 13px;
}

.group-235-15,
.group-235-16 {
  aspect-ratio: 1;
  background-color: var(--alto);
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/image-12-2@2x.png);
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 60px;
  height: 50px;
  left: 57px;
  position: absolute;
  top: 1px;
  width: 50px;
}

.number-8,
.number-9 {
  left: 30px;
  letter-spacing: 0.3px;
  line-height: normal;
  position: absolute;
  top: 13px;
}

.text-502,
.text-653 {
  left: 59px;
  letter-spacing: 0.34px;
  line-height: normal;
  position: absolute;
  top: 12px;
}
</style>
